import Sent from './Sent'
export default Sent
